import {useEffect} from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import theme from './theme/theme';
import HomePage from './pages/Home';
import WhyUsPage from './pages/WhyUs';
import BeginnerTrackPage from './pages/BeginnerLanding';
import ExperiencedTrackPage from './pages/ExperiencedLanding';
import AIMasteryLanding from './pages/AIMasteryLanding';
import CollegeProjectPage from './pages/CollegeProject';
import ContactPage from './pages/Contact';
import CourseLanding from './pages/CourseLanding';
import TransformLanding from './pages/TransformLanding';
import WebinarPage from './pages/Webinar';
import Blog from './pages/Blog';
import PrivacyPolicy from './pages/Privacy';
import { AppDataProvider } from './store/dataStore';
import EnrollNowPage from './pages/EnrollNowPage';
import GetHiredLanding from './pages/GetHiredLanding';
import { StickyCTA } from './components/StickyCTA';
import { useAnalytics } from './hooks/useAnalytics';
import CourseRedirector from './pages/CourseRedirector';
import WorkshopRegister from './pages/WorkshopRegister';
import FeaturesPage from './pages/Features';
//import OnboardingFlow from './components/switcher';
function App() {
    return (
        <ChakraProvider theme={theme}>
            <AppDataProvider>
                <Router>
                    <AppContent />
                </Router>
            </AppDataProvider>
        </ChakraProvider>
    );
}

// Create a separate component that uses Router hooks
function AppContent() {
    const { trackEvent } = useAnalytics(); // This is now inside Router context
    function OnboardingFlow() {
        useEffect(() => {
            window.location.replace('https://affiliates.ojasamirai.com');
        }, []);

        return <div>Loading affiliate portal...</div>;
    }

    return (
        <>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/course/:courseId" element={<CourseLanding />} />
                <Route path="/transform/:courseId" element={<TransformLanding />} />
                <Route path="/courses/:rawCourseId" element={<CourseRedirector />} />
                <Route path="/beginner-track" element={<BeginnerTrackPage />} />
                <Route path="/why-us" element={<WhyUsPage />} />
                <Route path="/experienced-track" element={<ExperiencedTrackPage />} />
                <Route path="/ai-mastery" element={<AIMasteryLanding />} />
                <Route path="/ai-career" element={<GetHiredLanding />} />
                <Route path="/college-project" element={<CollegeProjectPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/webinar" element={<WebinarPage />} />
                <Route path="/webinar-now" element={<WebinarPage />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/enroll" element={<EnrollNowPage />} />
                <Route path="/features" element={<FeaturesPage />} />
                <Route path="/register/:workshopId" element={<WorkshopRegister />} />
                <Route path="/now" element={<Navigate to="/register/215" replace />} />
                <Route path="/onboarding" element={<OnboardingFlow />} />
                <Route path="/affiliate" element={<OnboardingFlow />} />
            </Routes>
            <StickyCTA />
        </>
    );
}

export default App;